<template>
  <div class="instruments">

    <section class="section pt-0">
      <div class="pt-6 is-hidden-mobile"></div>
      <div class="container">
        <div class="columns">
          <div class="column is-3">
            <hr class="mb-6"
              style="border-top:1px solid #000 !important; height:1px !important; width:50px;">
            <p class="is-size-6 has-text-weight-semibold has-text-black">
              {{ $t('instruments.keyboard') }}
            </p>
          </div>
          <div class="column">

            <div class="column is-full px-0" v-if="loading">
              <div class="columns is-multiline">
                <div class="column is-half" v-for="i in media" :key="i">
                  <div class="media-content">
                    <figure class="image is-16by9 skeleton">
                      <div class="skeleton-block"></div>
                    </figure>
                  </div>
                </div>
              </div>
            </div>

            <div class="column is-full px-0" v-if="!loading">
              <div class="columns is-multiline">
                <div class="column is-half" v-for="tag in keyboard.slice(0, 4)" :key="tag.slug">
                  <router-link :to="{ path: '/instruments/' + tag.slug }">
                    <div class="card is-shadowless">
                      <div class="card-image">
                        <b-image
                          :src="'/assets/instruments/keyboard/webp/'+ tag.slug +'.webp'"
                          :webp-fallback="'/assets/instruments/keyboard/'+ tag.slug +'.jpg'"
                          :src-fallback="require('@/assets/no-instruments.jpg')"
                          :alt="tag.name"
                          ratio="is-16by9"
                        >
                        </b-image>
                      </div>
                      <div class="card-content is-overlay"
                        style="background-color: rgba(0,0,0,0.07);">
                        <span class="has-text-grey-dark has-text-weight-semibold is-size-5">
                          {{ tag.trans || tag.name }}
                        </span>
                      </div>
                    </div>
                  </router-link>
                </div>
              </div>
            </div>
          </div>
        </div>
        <hr class="my-3" style="border-top:1px solid #000 !important; height:1px !important;">
        <router-link to="/instruments/keyboard">
        <p class="is-size-6-desktop is-size-7-mobile
          has-text-weight-medium has-text-black has-text-right-desktop pt-3">
          {{ $t('instruments.morekeyboard') }}<i class="fas fa-long-arrow-alt-right ml-5 mb-5"></i>
        </p>
        </router-link>
      </div>
    </section>

    <section class="section">
      <div class="container">
        <div class="columns">
          <div class="column is-3">
            <hr class="mb-6"
              style="border-top:1px solid #000 !important; height:1px !important; width:50px;">
            <p class="is-size-6 has-text-weight-semibold has-text-black">
              {{ $t('instruments.string') }}
            </p>
          </div>
          <div class="column">

            <div class="column is-full px-0" v-if="loading">
              <div class="columns is-multiline">
                <div class="column is-half" v-for="i in media" :key="i">
                  <div class="media-content">
                    <figure class="image is-16by9 skeleton">
                      <div class="skeleton-block"></div>
                    </figure>
                  </div>
                </div>
              </div>
            </div>

            <div class="column is-full px-0">
              <div class="columns is-multiline">
                <div class="column is-half" v-for="tag in string.slice(0, 4)" :key="tag.slug">
                  <router-link :to="{ path: '/instruments/' + tag.slug }">
                    <div class="card is-shadowless">
                      <div class="card-image">
                        <b-image
                          :src="'/assets/instruments/string/webp/'+ tag.slug +'.webp'"
                          :webp-fallback="'/assets/instruments/string/'+ tag.slug +'.jpg'"
                          :src-fallback="require('@/assets/no-instruments.jpg')"
                          :alt="tag.name"
                          ratio="is-16by9"
                        >
                        </b-image>
                      </div>
                      <div class="card-content is-overlay"
                        style="background-color: rgba(0,0,0,0.07);">
                        <span class="has-text-grey-dark has-text-weight-semibold is-size-5">
                          {{ tag.trans || tag.name }}
                        </span>
                      </div>
                    </div>
                  </router-link>
                </div>
              </div>
            </div>
          </div>
        </div>
        <hr class="my-3" style="border-top:1px solid #000 !important; height:1px !important;">
        <router-link to="/instruments/string">
        <p class="is-size-6-desktop is-size-7-mobile
          has-text-weight-medium has-text-black has-text-right-desktop pt-3">
          {{ $t('instruments.morestring') }}<i class="fas fa-long-arrow-alt-right ml-5 mb-5"></i>
        </p>
        </router-link>
      </div>
    </section>

    <section class="section">
      <div class="container">
        <div class="columns">
          <div class="column is-3">
            <hr class="mb-6"
              style="border-top:1px solid #000 !important; height:1px !important; width:50px;">
            <p class="is-size-6 has-text-weight-semibold has-text-black">
              {{ $t('instruments.wind') }}
            </p>
          </div>
          <div class="column">

            <div class="column is-full px-0" v-if="loading">
              <div class="columns is-multiline">
                <div class="column is-half" v-for="i in media" :key="i">
                  <div class="media-content">
                    <figure class="image is-16by9 skeleton">
                      <div class="skeleton-block"></div>
                    </figure>
                  </div>
                </div>
              </div>
            </div>

            <div class="column is-full px-0">
              <div class="columns is-multiline">
                <div class="column is-half" v-for="tag in wind.slice(0, 4)" :key="tag.slug">
                  <router-link :to="{ path: '/instruments/' + tag.slug }">
                    <div class="card is-shadowless">
                      <div class="card-image">
                        <b-image
                          :src="'/assets/instruments/wind/webp/'+ tag.slug +'.webp'"
                          :webp-fallback="'/assets/instruments/wind/'+ tag.slug +'.jpg'"
                          :src-fallback="require('@/assets/no-instruments.jpg')"
                          :alt="tag.name"
                          ratio="is-16by9"
                        >
                        </b-image>
                      </div>
                      <div class="card-content is-overlay"
                        style="background-color: rgba(0,0,0,0.07);">
                        <span class="has-text-grey-dark has-text-weight-semibold is-size-5">
                          {{ tag.trans || tag.name }}
                        </span>
                      </div>
                    </div>
                  </router-link>
                </div>
              </div>
            </div>
          </div>
        </div>
        <hr class="my-3" style="border-top:1px solid #000 !important; height:1px !important;">
        <router-link to="/instruments/wind">
        <p class="is-size-6-desktop is-size-7-mobile
          has-text-weight-medium has-text-black has-text-right-desktop pt-3">
          {{ $t('instruments.morewind') }}<i class="fas fa-long-arrow-alt-right ml-5 mb-5"></i>
        </p>
        </router-link>
      </div>
    </section>

    <section class="section">
      <div class="container">
        <div class="columns">
          <div class="column is-3">
            <hr class="mb-6"
              style="border-top:1px solid #000 !important; height:1px !important; width:50px;">
            <p class="is-size-6 has-text-weight-semibold has-text-black">
              {{ $t('instruments.percussion') }}
            </p>
          </div>
          <div class="column">

            <div class="column is-full px-0" v-if="loading">
              <div class="columns is-multiline">
                <div class="column is-half" v-for="i in media" :key="i">
                  <div class="media-content">
                    <figure class="image is-16by9 skeleton">
                      <div class="skeleton-block"></div>
                    </figure>
                  </div>
                </div>
              </div>
            </div>

            <div class="column is-full px-0">
              <div class="columns is-multiline">
                <div class="column is-half" v-for="tag in percussion.slice(0, 4)" :key="tag.slug">
                  <router-link :to="{ path: '/instruments/' + tag.slug }">
                    <div class="card is-shadowless">
                      <div class="card-image">
                        <b-image
                          :src="'/assets/instruments/percussion/webp/'+ tag.slug +'.webp'"
                          :webp-fallback="'/assets/instruments/percussion/'+ tag.slug +'.jpg'"
                          :src-fallback="require('@/assets/no-instruments.jpg')"
                          :alt="tag.name"
                          ratio="is-16by9"
                        >
                        </b-image>
                      </div>
                      <div class="card-content is-overlay"
                        style="background-color: rgba(0,0,0,0.07);">
                        <span class="has-text-grey-dark has-text-weight-semibold is-size-5">
                          {{ tag.trans || tag.name }}
                        </span>
                      </div>
                    </div>
                  </router-link>
                </div>
              </div>
            </div>
          </div>
        </div>
        <hr class="my-3" style="border-top:1px solid #000 !important; height:1px !important;">
        <router-link to="/instruments/percussion">
        <p class="is-size-6-desktop is-size-7-mobile
          has-text-weight-medium has-text-black has-text-right-desktop pt-3">
          {{ $t('instruments.morepercussion') }}
          <i class="fas fa-long-arrow-alt-right ml-5 mb-5"></i>
        </p>
        </router-link>
      </div>
    </section>

  </div>
</template>

<script>
import { getTags } from '@/api/api';

export default {
  name: 'Explore',

  data() {
    return {
      loading: true,
      media: 4,
      keyboard: [],
      string: [],
      wind: [],
      percussion: [],
    };
  },

  created() {
    this.fetchData();
  },

  methods: {
    fetchData() {
      getTags(null, { headers: { locale: this.$i18n.locale } })
        .then((result) => {
          const { data } = result.data;

          this.keyboard = data.filter((item) => item.type === 'keyboard');
          this.string = data.filter((item) => item.type === 'string');
          this.wind = data.filter((item) => item.type === 'wind');
          this.percussion = data.filter((item) => item.type === 'percussion');

          this.loading = false;
        })
        .catch((err) => { console.error(err); });
    },
  },
};
</script>
